'use client'

import { ComponentProps } from 'react'

import { cn } from '@/shared/lib'

import { useCarousel } from './lib/use-carousel'
import { IconButton as _IconButton } from '../button/icon-button'

type CarouselButtonProps = Omit<ComponentProps<typeof _IconButton>, 'name'> & {
  name?: string
}

export const Previous = ({
  name = 'arrow-left',
  size = 'small',
  variant = 'outline',
  shape = 'pill',
  className,
  ...props
}: CarouselButtonProps) => {
  const { orientation, scrollPrev, canScrollPrev, scrollSnaps } = useCarousel()

  if (scrollSnaps.length <= 1) return null

  return (
    <_IconButton
      data-slot="carousel-previous"
      name={name}
      variant={variant}
      size={size}
      shape={shape}
      className={cn(
        'absolute',
        orientation === 'horizontal'
          ? 'top-1/2 left-2 -translate-y-1/2'
          : 'top-2 left-1/2 -translate-x-1/2 rotate-90',
        'disabled:pointer-events-auto',
        className,
      )}
      disabled={!canScrollPrev}
      onClick={scrollPrev}
      aria-label="이전 슬라이드로 이동"
      {...props}
    />
  )
}

export const Next = ({
  name = 'arrow-right',
  size = 'small',
  variant = 'outline',
  shape = 'pill',
  className,
  ...props
}: CarouselButtonProps) => {
  const { orientation, scrollNext, canScrollNext, scrollSnaps } = useCarousel()

  if (scrollSnaps.length <= 1) return null

  return (
    <_IconButton
      data-slot="carousel-next"
      name={name}
      variant={variant}
      size={size}
      shape={shape}
      className={cn(
        'absolute',
        orientation === 'horizontal'
          ? 'top-1/2 right-2 -translate-y-1/2'
          : 'bottom-2 left-1/2 -translate-x-1/2 rotate-90',
        'disabled:pointer-events-auto',
        className,
      )}
      disabled={!canScrollNext}
      onClick={scrollNext}
      aria-label="다음 슬라이드로 이동"
      {...props}
    />
  )
}

export const IconButton = () => {
  return (
    <>
      <Previous />
      <Next />
    </>
  )
}
